export enum MarketExplorerGamesChartAxisId {
  Y = 'y',
  X = 'x',
}
